export default {
  badges: [],
  userBadges: [],
  unlockedBadges: []
}
